// import React, { useEffect, useState } from "react";
// import { useCookies } from "react-cookie";
// import { getValidAccessToken } from "../services/garphService";
// import { useMsal } from "@azure/msal-react";
// import * as microsoftTeams from "@microsoft/teams-js";
// import { useState, useEffect } from "react";

// // Accurate Teams detection
// const detectTeams = () =>
//   new Promise((resolve) => {
//     microsoftTeams.app.getContext()
//       .then(() => resolve(true))
//       .catch(() => resolve(false));
//   });

// const DocumentModal = ({ open, onClose, metadata, metadataFields = [] }) => {
//   const [fileUrl, setFileUrl] = useState(null);
//   const [fileType, setFileType] = useState(null);
//   const [isTeams, setIsTeams] = useState(false);
//   const { instance, accounts } = useMsal();
//   const [cookies] = useCookies([
//     "email", "firstName", "lastName", "roleName", "roleId", "accessToken", "fullname"
//   ]);

//   useEffect(() => {
//     const fetchFile = async () => {
//       try {
//         const inTeams = await detectTeams();
//         setIsTeams(inTeams);

//         let token;
//         if (inTeams) {
//           token = await new Promise((resolve, reject) => {
//             microsoftTeams.authentication.getAuthToken({
//               successCallback: (token) => resolve(token),
//               failureCallback: (err) => reject(err),
//               resources: ["https://graph.microsoft.com"]
//             });
//           });
//         } else {
//           token = await getValidAccessToken(instance, accounts);
//         }

//         if (!metadata?.sharepoint_id || !token) return;

//         const response = await fetch(
//           `https://land-documents-dev-ejcuftebf0dzg0e8.centralindia-01.azurewebsites.net/api/proxy-file?document_id=${metadata.sharepoint_id}`,
//           {
//             method: "GET",
//             headers: { Authorization: `Bearer ${token}` }
//           }
//         );

//         if (!response.ok) throw new Error("Failed to load file");

//         const contentType = response.headers.get("content-type");
//         setFileType(contentType);

//         if (inTeams && contentType.includes("pdf")) {
//           setFileUrl("teams-pdf"); // Skip iframe in Teams
//           return;
//         }

//         if (["pdf", "image", "text"].some((type) => contentType.includes(type))) {
//           const blob = await response.blob();
//           const url = URL.createObjectURL(blob);
//           setFileUrl(url);
//         } else {
//           setFileUrl("download");
//         }
//       } catch (err) {
//         console.error("Error loading file:", err);
//       }
//     };

//     if (open) {
//       fetchFile();
//     }

//     return () => {
//       if (fileUrl && fileUrl !== "download" && fileUrl !== "teams-pdf") {
//         URL.revokeObjectURL(fileUrl);
//       }
//     };
//   }, [open, metadata]);

//   if (!open || !metadata) return null;

//   return (
//     <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 overflow-y-auto">
//       <div className="bg-white rounded-lg shadow-lg w-full max-w-4xl md:w-3/4 lg:w-2/3 xl:w-1/2 p-2 sm:p-4 relative mx-2 my-4">
//         <button
//           onClick={onClose}
//           className="absolute top-2 right-3 text-xl font-bold"
//           aria-label="Close modal"
//         >
//           &times;
//         </button>

//         <h2 className="text-lg sm:text-xl font-semibold mb-2 sm:mb-4">Metadata</h2>

//         <div className="flex flex-col md:flex-row gap-2 sm:gap-4">
//           {/* Metadata */}
//           <div className="md:w-1/3 w-full text-xs sm:text-sm text-gray-700 space-y-2 sm:space-y-3 max-h-60 sm:max-h-[500px] overflow-y-auto pr-2">
//             {metadataFields.map(({ key, label }) =>
//               metadata[key] !== undefined ? (
//                 <div key={key}>
//                   <strong>{label || key}:</strong>
//                   <div>{metadata[key]}</div>
//                 </div>
//               ) : null
//             )}
//           </div>

//           {/* File Preview */}
//           <div className="md:w-2/3 w-full border rounded max-h-60 sm:max-h-[500px] overflow-hidden flex justify-center items-center p-2 sm:p-4">
//             {fileUrl === "download" ? (
//               <div className="text-center">
//                 <p className="text-red-600 mb-2">This file type cannot be displayed inline.</p>
//                 <a
//                   href={`https://land-documents-dev-ejcuftebf0dzg0e8.centralindia-01.azurewebsites.net/api/proxy-file?document_id=${metadata.sharepoint_id}`}
//                   download
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="inline-block px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
//                 >
//                   Download File
//                 </a>
//               </div>
//             ) : fileUrl === "teams-pdf" ? (
//               <div className="text-center">
//                 <p className="mb-2 text-gray-700">PDF preview is not supported in Teams.</p>
//                 <button
//                   onClick={() => {
//                     if (metadata?.url) {
//                       window.open(metadata.url, "_blank");
//                     } else {
//                       alert("No file URL available.");
//                     }
//                   }}
//                   className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
//                 >
//                   Open PDF in New Tab
//                 </button>
//               </div>
//             ) : fileType?.includes("pdf") ? (
//               <iframe
//                 src={fileUrl}
//                 title="PDF Preview"
//                 className="w-full h-full min-h-[400px] border-none"
//               />
//             ) : fileType?.includes("image") ? (
//               <img src={fileUrl} alt="Preview" className="max-w-full max-h-full" />
//             ) : fileUrl ? (
//               <iframe
//                 src={fileUrl}
//                 title="File Preview"
//                 className="w-full h-full min-h-[200px] border-none"
//               />
//             ) : (
//               <div>Loading file...</div>
//             )}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// import React, { useEffect, useState } from "react";
// import { useCookies } from "react-cookie";
// import { getValidAccessToken } from "../services/garphService";
// import { useMsal } from "@azure/msal-react";
// import * as microsoftTeams from '@microsoft/teams-js';

// // Utility to detect Teams context
// function isInTeams() {
//   try {
//     return window.self !== window.top && window.name === "embedded-page-container";
//   } catch {
//     return false;
//   }
// }

// const DocumentModal = ({ open, onClose, metadata, metadataFields = [] }) => {
//   const [fileUrl, setFileUrl] = useState(null);
//   const { instance, accounts } = useMsal();
//   const [fileType, setFileType] = useState(null);
//   const [cookies, setCookie] = useCookies([
//     "email",
//     "firstName",
//     "lastName",
//     "roleName",
//     "roleId",
//     "accessToken",
//     "fullname"
//   ]);

//   useEffect(() => {
//     const fetchFile = async () => {
//       try {
//         let token;

//         // const isInTeams = window.self !== window.top && window.name === "embedded-page-container";
//         const isInTeamsContext = isInTeams();

//         if (isInTeamsContext) {
//           token = await new Promise((resolve, reject) => {
//             window.microsoftTeams?.authentication.getAuthToken({
//               successCallback: (token) => resolve(token),
//               failureCallback: (err) => reject(err),
//               resources: ['https://graph.microsoft.com']
//             });
//           });
//         } else {
//           token = await getValidAccessToken(instance, accounts);
//         }

//         if (!metadata?.sharepoint_id || !token) return;

//         const response = await fetch(
//           `https://land-documents-dev-ejcuftebf0dzg0e8.centralindia-01.azurewebsites.net/api/proxy-file?document_id=${metadata.sharepoint_id}`,
//           {
//             method: "GET",
//             headers: {
//               Authorization: `Bearer ${token}`,
//             },
//           }
//         );

//         if (!response.ok) throw new Error("Failed to load file");

//         const contentType = response.headers.get("content-type");
//         setFileType(contentType);

//         if (isInTeamsContext && contentType.includes("pdf")) {
//           // For Teams PDF, use the blob URL like other contexts
//           const blob = await response.blob();
//           const url = URL.createObjectURL(blob);
//           setFileUrl(url);
//           setFileType(contentType);
//           console.log("Teams detected with PDF, using blob URL:", url);
//           return;
//         }

//         if (contentType.includes("pdf") || contentType.includes("image") || contentType.includes("text")) {
//           const blob = await response.blob();
//           const url = URL.createObjectURL(blob);
//           setFileUrl(url);
//           console.log("Setting fileUrl to blob URL:", url);
//         } else {
//           setFileUrl("download");
//           console.log("Setting fileUrl to download");
//         }
//       } catch (error) {
//         console.error("Error loading file:", error);
//       }
//     };

//     if (open) {
//       fetchFile();
//     }

//     return () => {
//       if (fileUrl && fileUrl !== "download" && fileUrl !== "teams-pdf") {
//         URL.revokeObjectURL(fileUrl);
//       }
//     };
//   }, [open, metadata]);

//   console.log("Modal open:", open);
//   console.log("Received metadata.sharepoint_id:", metadata?.sharepoint_id);

//   if (!open || !metadata) return null;

//   return (
//     <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 overflow-y-auto">
//       <div
//         className="bg-white rounded-lg shadow-lg w-full max-w-4xl md:w-3/4 lg:w-2/3 xl:w-1/2 p-2 sm:p-4 relative mx-2 my-4"
//       >
//         <button
//           onClick={onClose}
//           className="absolute top-2 right-3 text-xl font-bold"
//           aria-label="Close modal"
//         >
//           &times;
//         </button>

//         <h2 className="text-lg sm:text-xl font-semibold mb-2 sm:mb-4">Metadata</h2>

//         <div className="flex flex-col md:flex-row gap-2 sm:gap-4">
//           {/* Dynamic Metadata Column */}
//           <div className="md:w-1/3 w-full text-xs sm:text-sm text-gray-700 space-y-2 sm:space-y-3 max-h-60 sm:max-h-[500px] overflow-y-auto pr-2">
//             {metadataFields.map(({ key, label }) => (
//               metadata[key] !== undefined && (
//                 <div key={key}>
//                   <strong>{label || key}:</strong>
//                   <div>{metadata[key]}</div>
//                 </div>
//               )
//             ))}
//           </div>

//           <div className="md:w-2/3 w-full border rounded max-h-60 sm:max-h-[500px] overflow-hidden flex justify-center items-center">
//             {fileUrl === "download" ? (
//               <div className="text-center p-2">
//                 <p className="text-red-600 mb-2">This file type cannot be displayed inline.</p>
//                 <a
//                   href={`https://land-documents-dev-ejcuftebf0dzg0e8.centralindia-01.azurewebsites.net/api/proxy-file?document_id=${metadata.sharepoint_id}`}
//                   download
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="inline-block px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
//                 >
//                   Download File
//                 </a>
//               </div>
//             ) : fileUrl === "teams-pdf" ? (
//               <div className="text-center p-4">
//                 <p className="text-gray-700 mb-2">PDF preview is not supported in Teams. Click below to open in SharePoint.</p>
//                 <button
//                   onClick={() => {
//                     microsoftTeams.tasks.startTask({
//                       title: "View Document",
//                       url: fileUrl,
//                       height: "large",
//                       width: "large",
//                     });
//                   }}
//                   className="inline-block px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
//                 >
//                   Open in SharePoint
//                 </button>
//               </div>
//             ) : fileUrl ? (
//               fileType?.includes("pdf") ? (
//                 isInTeams() ? (
//                   // For Teams: Use <object>/<embed> structure for PDF rendering
//                   <object
//                     data={fileUrl}
//                     type="application/pdf"
//                     width="100%"
//                     height="600px"
//                   >
//                     <embed
//                       src={fileUrl}
//                       type="application/pdf"
//                       width="100%"
//                       height="600px"
//                     />
//                     <p>PDF cannot be displayed.</p>
//                   </object>
//                 ) : (
//                   <embed src={fileUrl} type="application/pdf" className="w-full h-full min-h-[200px]" />
//                 )
//               ) : fileType?.includes("image") ? (
//                 <img src={fileUrl} alt="Preview" className="max-w-full max-h-full" />
//               ) : (
//                 <iframe src={fileUrl} title="File Preview" className="w-full h-full border-none min-h-[200px]" />
//               )
//             ) : (
//               <div>Loading file...</div>
//             )}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default DocumentModal;

import React, { useEffect, useState } from "react";
import { Worker, Viewer } from "@react-pdf-viewer/core";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import { toolbarPlugin } from "@react-pdf-viewer/toolbar";

import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import "@react-pdf-viewer/toolbar/lib/styles/index.css";
import PdfViewerToolbar, { RESTRICTED_TOOLBAR_OPTIONS } from "./pdfViewerToolbar";
import { useMsal } from "@azure/msal-react";
import { useCookies } from "react-cookie";
import { CircularProgress } from "@mui/material";
import { getValidAccessToken } from "../services/garphService";
import * as microsoftTeams from "@microsoft/teams-js";
// import "react-pdf/dist/esm/Page/AnnotationLayer.css";
// import "react-pdf/dist/esm/Page/TextLayer.css";
import { imageToPdf } from "./imageToPdf";
// pdfjs.GlobalWorkerOptions.workerSrc = "/pdf.worker.min.js";

// Teams detection using SDK
const detectTeams = () =>
  new Promise((resolve) => {
    microsoftTeams.app
      .getContext()
      .then(() => resolve(true))
      .catch(() => resolve(false));
  });

const DocumentModal = ({ open, onClose, metadata, metadataFields = [] }) => {
  const { instance, accounts } = useMsal();
  const [cookies] = useCookies(["permissions"]);
  const [fileUrl, setFileUrl] = useState(null);
  const [fileType, setFileType] = useState(null);
  const [isTeams, setIsTeams] = useState(false);
  const [loading, setLoading] = useState(false);
  // const [numPages, setNumPages] = useState(null);
  const DOWNLOAD_ALLOWED_ROLES = [
    "Admin",
    // "Spoc",
    "State Admin",

    //"Location Admin",
  ];
  const isAdminOrSpoc = DOWNLOAD_ALLOWED_ROLES.includes(cookies.permissions);
  const toolbarPluginInstance = toolbarPlugin(RESTRICTED_TOOLBAR_OPTIONS);

  const defaultLayoutPluginInstance = defaultLayoutPlugin({
    sidebarTabs: () => [],
    toolbarPlugin: {
      instance: toolbarPluginInstance,
    },
  });
  useEffect(() => {
    const fetchFile = async () => {
      try {
        setLoading(true); // ✅ start spinner
        const inTeams = await detectTeams();
        setIsTeams(inTeams);

        let token;
        if (inTeams) {
          token = await new Promise((resolve, reject) => {
            microsoftTeams.authentication.getAuthToken({
              successCallback: (token) => resolve(token),
              failureCallback: (err) => reject(err),
              resources: ["https://graph.microsoft.com"],
            });
          });
        } else {
          token = await getValidAccessToken(instance, accounts);
        }

        if (!metadata?.sharepoint_id || !token) return;

        const response = await fetch(
          `https://land-documents-dev-ejcuftebf0dzg0e8.centralindia-01.azurewebsites.net/api/proxy-file?document_id=${metadata.sharepoint_id}`,
          {
            method: "GET",
            headers: { Authorization: `Bearer ${token}` },
          },
        );

        if (!response.ok) throw new Error("Failed to load file");

        const contentType = response.headers.get("content-type");
        setFileType(contentType);

        if (inTeams && contentType.includes("pdf")) {
          setFileUrl("teams-pdf");
          return;
        }

        if (
          ["pdf", "image", "text"].some((type) => contentType.includes(type))
        ) {
          const blob = await response.blob();

          if (contentType.includes("image")) {
            // Convert image to PDF
            const pdfUrl = await imageToPdf(blob);

            setFileUrl(pdfUrl);
            setFileType("application/pdf");
          } else {
            const url = URL.createObjectURL(blob);

            setFileUrl(url);
          }
        } else {
          setFileUrl("download");
        }
      } catch (error) {
        console.error("Error loading file:", error);
      } finally {
        setLoading(false); // ✅ stop spinner
      }
    };

    if (open) {
      fetchFile();
    }
    return () => {
      if (fileUrl && fileUrl !== "download" && fileUrl !== "teams-pdf") {
        URL.revokeObjectURL(fileUrl);
      }
    };
  }, [open, metadata]);

  // ❌ Disable right-click & shortcuts
  useEffect(() => {
    const disableKeys = (e) => {
      if (
        (e.ctrlKey && ["s", "p"].includes(e.key.toLowerCase())) ||
        e.key === "PrintScreen"
      ) {
        e.preventDefault();
      }
    };
    window.addEventListener("keydown", disableKeys);
    return () => window.removeEventListener("keydown", disableKeys);
  }, []);

  if (!open || !metadata) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 overflow-y-auto"
      onContextMenu={(e) => e.preventDefault()}
    >
      {/* <div className="bg-white rounded-lg shadow-lg w-full max-w-4xl md:w-3/4 lg:w-2/3 xl:w-1/2 p-2 sm:p-4 relative mx-2 my-4"> */}
      <div className="bg-white rounded-lg shadow-lg w-[95vw] h-[90vh] max-w-[1400px] p-4 relative mx-2 my-4 flex flex-col">
        <button
          onClick={onClose}
          className="absolute top-2 right-3 text-xl font-bold"
          aria-label="Close modal"
        >
          &times;
        </button>

        <h2 className="text-lg sm:text-xl font-semibold mb-2 sm:mb-4">
          Metadata
        </h2>

        <div className="flex gap-4 flex-1 overflow-hidden">
          {/* Metadata */}
          <div
            className="md:w-1/4 w-full text-xs sm:text-sm text-gray-700 space-y-2 sm:space-y-3 h-full overflow-y-auto pr-2"
            onContextMenu={(e) => e.preventDefault()}
          >
            {metadataFields.map(({ key, label }) =>
              metadata[key] !== undefined ? (
                <div key={key}>
                  <strong>{label || key}:</strong>
                  <div>{metadata[key]}</div>
                </div>
              ) : null,
            )}
          </div>
          <div className="md:w-3/4 w-full border rounded h-full overflow-y-auto flex justify-center items-center p-2 sm:p-4">
            {loading ? (
              <CircularProgress sx={{ color: "gray" }} />
            ) : fileUrl === "download" ? (
              <div className="text-center">
                <p className="text-red-600 mb-2">
                  This file type cannot be displayed inline.
                </p>
                {isAdminOrSpoc && (
                <a
                  href={`/proxy-file?document_id=${metadata.sharepoint_id}`}
                  download
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
                >
                  Download File
                </a>
                )}
              </div>
            ) : fileUrl === "teams-pdf" ? (
              <div className="text-center">
                <p className="mb-2 text-gray-700">
                  PDF preview is not supported in Teams.
                </p>
                <button
                  onClick={() => {
                    if (metadata?.url) {
                      window.open(metadata.url, "_blank");
                    } else {
                      alert("No file URL available.");
                    }
                  }}
                  className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
                >
                  Open PDF in New Tab
                </button>
              </div>
            ) : fileUrl ? (
              fileType?.includes("pdf") ? (
                isAdminOrSpoc ? (
                  // Admin/Spoc: iframe for PDF
                  <iframe
                    src={`${fileUrl}#toolbar=1`}
                    className="w-full h-full border-none"
                    title="PDF Preview"
                  />
                ) : (
                  // Other users: react-pdf
                  // <div
                  //   className="w-full h-full overflow-auto"
                  //   onContextMenu={(e) => e.preventDefault()}
                  //   style={{ userSelect: "none" }}
                  // >
                  //   <Document
                  //     file={fileUrl}
                  //     onLoadSuccess={({ numPages }) => setNumPages(numPages)}
                  //     loading={<CircularProgress />}
                  //   >
                  //     {Array.from(new Array(numPages), (_, index) => (
                  //       <Page
                  //         key={index}
                  //         pageNumber={index + 1}
                  //         renderTextLayer={false}
                  //         renderAnnotationLayer={false}
                  //       />
                  //     ))}
                  //   </Document>
                  // </div>

                  <div
                    className="w-full h-full flex flex-col"
                    onContextMenu={(e) => e.preventDefault()}
                  >
                    <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
                      <PdfViewerToolbar
                        toolbarPluginInstance={toolbarPluginInstance}
                      />

                      {/* Viewer fills the space left under the toolbar and scrolls itself,
                          so the outer preview panel never gets a second scrollbar */}
                      <div className="flex-1 min-h-0">
                        <Viewer
                          fileUrl={fileUrl}
                          plugins={[toolbarPluginInstance]}
                        />
                      </div>
                    </Worker>
                  </div>
                )
              ) : fileType?.includes("image") ? (
                <img
                  src={fileUrl}
                  alt="Preview"
                  onContextMenu={(e) => e.preventDefault()}
                  className="max-w-full max-h-full"
                />
              ) : (
                // For all users: iframe for other file types
                <iframe
                  src={fileUrl}
                  title="File Preview"
                  className="w-full h-full border-none"
                />
              )
            ) : (
              <div>No preview available</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DocumentModal;
